<template>
    <v-dialog
        v-model="dialog"
        :max-width="options.width"
        v-bind:style="{ zIndex: options.zIndex }"
        :persistent="true">
        <v-card>
            <v-card-title class="title blue-title pa-3 pt-4 ml-2">
                Binding Mobile Phone
            </v-card-title>

            <v-card-text class="pa-4">
                <v-form v-model="phoneValid" ref="phoneForm">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-flex xs12>
                                <v-subheader class="form-title pl-0">Phone Number</v-subheader>
                            </v-flex>
                            <v-layout row>
                                <v-flex xs2 pr-3>
                                    <span class="binding-area">+&nbsp;
                                        <input type="text" name="" id="" class="area-code" v-model="areaCode">
                                    </span>
                                </v-flex>
                                <v-flex xs10>
                                    <v-text-field
                                        single-line
                                        outline
                                        box
                                        class="body-2"
                                        v-model.trim="phoneNumber"
                                        :rules="[rules.required]"
                                        required
                                        oninput="value=value.replace(/[^0-9-]+/,'')"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex> 
                    </v-layout>
                </v-form>
                <v-form v-model="codeValid" ref="codeForm">
                    <v-layout row wrap>
                        <v-flex xs8 pr-3>
                            <v-flex xs12>
                                <v-subheader class="form-title pl-0">Verification Code</v-subheader>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                    single-line
                                    outline
                                    box
                                    class="body-2"
                                    v-model.trim="verificationCode"
                                    required
                                    :rules="[rules.required]"
                                    oninput="value=value.replace(/[^0-9-]+/,'')"
                                    ></v-text-field>
                            </v-flex>
                        </v-flex> 
                        <v-flex xs4>
                            <v-btn
                                text
                                @click="sendCode"
                                class="text-none white--text blue-button send"
                                :disabled="!canGet"
                            >
                            {{getCodeBtn}}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
                <p style="color: rgba(50, 57, 122, 0.4)">* Please make sure it is your contact information</p>
            </v-card-text>

            <div class="binding-footer">
                <div class="flex-grow-1"></div>
                <v-btn
                    class="text-none blue-button"
                    text
                    @click="remindLater"
                >
                    Remind in 6 hours
                </v-btn>
                <v-btn
                    class="text-none red-button"
                    text
                    @click="bindPhone"
                >
                    Submit
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import { bindTutorPhone , sendVerificationCode, remindMeLater } from '@/api/teachinfo'
export default {
    data: ()=>({
        dialog:false,
        phoneNumber:'',
        verificationCode:'',
        canGet: true,
        timer: null,
        count: 60,
        getCodeBtn:"Send",
        options:{
            width: 550,
            zIndex: 200
        },
        areaCode:'63',
        notNumber:false,
        phoneValid: false,
        codeValid: false,
        rules: {
            required: value => !!value || 'Required.'
        },
    }),
    methods:{
        async sendCode(){
            this.verificationCode = ''
            this.$refs.codeForm.resetValidation()
            if (!this.$refs.phoneForm.validate()) {
                return
            }
             let resInfo = await sendVerificationCode(this.phoneNumber,"+"+this.areaCode).then(res=>{
                return res.data;
            })
            if (!this.timer && resInfo.ErrorCode==0) {
                const TIME_COUNT = 60;
                this.count = TIME_COUNT;
                this.canGet = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                        this.getCodeBtn = '('+this.count+")s";
                    } else {
                        this.canGet = true;
                        clearInterval(this.timer);
                        this.timer = null;
                        this.getCodeBtn = 'Send'
                    }
                }, 1000)
            }
           
            let type = resInfo.ErrorCode===0?'success':'error';
           this.$root.$alertTips(resInfo.Msg,type);
        },
        async bindPhone(){
            if (!this.$refs.codeForm.validate() || !this.$refs.phoneForm.validate()) {
                return
            }
            
            let resInfo = await bindTutorPhone(this.phoneNumber, this.verificationCode,"+"+this.areaCode).then(res=>{
                return res.data;
            })
            switch (resInfo.ErrorCode) {
                case 2:
                    this.$root.$alertTips('Verification code input error',"error");
                    break;
                case 0:
                    this.dialog = false;
                    this.$root.$alertTips("Binding success","success");
                    break;
            
                default:
                    this.$root.$alertTips(resInfo.Msg,"error");
                    break;
                
            }
        },
        remindLater(){
            remindMeLater();
            this.dialog = false;
        }
    },
    mounted(){
        if(this.$store.state.user.isNeedUpdatePhone) this.dialog = true;
    },
    watch:{
        dialog(val){
            if(!val && this.timer){
                clearInterval(this.timer);
                this.timer = null;
            }
        }
    }
}
</script>

<style scoped>
    .v-card__title{
        justify-content: flex-start !important; 
    }
    .red-button, .blue-button{
        height: 28px;
    }
    .send{
        width: 100%;
        height: 40px;
        margin-left: 0;
        margin-top: 30px;
    }
    .headline{
        font-weight: bold;
    }
    .v-card__title{
        justify-content: center;
    }
    .v-btn--icon{
        position: absolute;
        right: 0;
        top: 0;
    }
    .binding-footer{
        text-align: center;
        margin-top: 30px;
        height: 60px;
    }
    .binding-area{
        width:100%;
        height: 40px;
        background-color: #fff;
        font-weight: bold;
        line-height: 38px;
        padding-left: 10px;
        border:1px solid rgba(50, 57, 122, 0.4);
        border-radius: 4px;
        display: flex;
        color: #32397A;
    }
    .area-code{
        width: 100%;
        border-radius: 4px;
        outline: none;
        background-color: #fff;
        color: #32397A;
    }
</style>